module.exports = __webpack_public_path__ + "static/lotta_sea_lice-e322d503e51e3068ae59eb27c700ecf2.png";